import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnInit,
  OnChanges,
} from '@angular/core';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
// import { catLifeStages, dogLifeStages } from '../life-stages';

export interface TableItem {
  id?: string;
  name: string;
  filename?: string;
  url?: string;
  docType?: string;
  species?: string;
  blobUrl?: string;
  originalFilename?: string;
  lifeStage?: string;
  _index?: number;
}

@Component({
  selector: 'lib-documents-links',
  templateUrl: './documents-links.component.html',
  styleUrls: ['./documents-links.component.css'],
})
export class DocumentsLinksComponent implements OnInit, OnChanges {
  @Input() searchPlaceholder = 'Search Documents and Links';
  @Input() height = '500px';
  @Input() items: TableItem[] = [];
  @Input() showPetszelWarning = false;
  @Input() canWrite = true;

  @Output() add = new EventEmitter<void>();
  @Output() edit = new EventEmitter<TableItem>();
  @Output() delete = new EventEmitter<{ item: TableItem; index: number }>();
  @Output() reorderSaved = new EventEmitter<TableItem[]>();

  searchQuery = '';
  filteredItems: TableItem[] = [];

  // Reordering state
  isReordering = false;
  private originalItems: TableItem[] = [];
  movedItemId: string | null = null;

  // catLifeStages = catLifeStages;
  // dogLifeStages = dogLifeStages;

  ngOnInit() {
    this.filteredItems = [...this.items];
  }

  ngOnChanges() {
    this.filteredItems = this.searchQuery
      ? this.filterItems(this.searchQuery, this.items)
      : [...this.items];
  }

  private getDisplayableSearchText(item: TableItem): string {
    const normalizedSpecies = item.species?.trim() || 'All';

    return [
      item.name,
      item.docType,
      normalizedSpecies,
      item.filename,
      item.originalFilename,
      item.url,
      item.blobUrl,
    ]
      .filter(Boolean)
      .map((val) => val!.toLowerCase())
      .join(' ');
  }

  // getLifeStageLabel(item: TableItem): string {
  //   if (!item.lifeStage || item.lifeStage === 'All') {
  //     return 'All';
  //   }

  //   const species = item.species?.toLowerCase();

  //   // Handle when no species selected, or explicitly "All"
  //   if (!species || species === 'all') {
  //     const allLifeStages = [...this.catLifeStages, ...this.dogLifeStages];
  //     const found = allLifeStages.find((opt) => opt.value === item.lifeStage);
  //     return found ? found.label : item.lifeStage;
  //   }

  //   if (species === 'feline' || species === 'cat') {
  //     const found = this.catLifeStages.find(
  //       (opt) => opt.value === item.lifeStage
  //     );
  //     return found ? found.label : item.lifeStage;
  //   }

  //   if (species === 'canine' || species === 'dog') {
  //     const found = this.dogLifeStages.find(
  //       (opt) => opt.value === item.lifeStage
  //     );
  //     return found ? found.label : item.lifeStage;
  //   }

  //   return item.lifeStage;
  // }

  onSearch(query: string) {
    this.searchQuery = query;
    this.filteredItems = this.filterItems(query, this.items);
  }

  private filterItems(query: string, data: TableItem[]): TableItem[] {
    if (!query) return [...data];
    const lowerQuery = query.toLowerCase();

    return data.filter((item) => {
      const text = this.getDisplayableSearchText(item);
      console.log('Item search text:', text);
      const regex = new RegExp(`\\b${lowerQuery}\\b`, 'i');
      return regex.test(text);
    });
  }

  // Basic actions
  addClicked() {
    this.add.emit();
  }
  editClicked(item: TableItem) {
    this.edit.emit(item);
  }
  deleteClicked(item: TableItem, index: number) {
    this.delete.emit({ item, index });
  }

  isLink(item: TableItem): boolean {
    return !!item.url && !item.blobUrl;
  }

  // --- Reorder Logic ---
  toggleReorder() {
    // Enter reorder mode
    this.isReordering = true;
    // Store a copy in case of cancel
    this.originalItems = [...this.filteredItems];
  }

  drop(event: CdkDragDrop<TableItem[]>) {
    if (event.previousIndex === event.currentIndex) return;

    moveItemInArray(
      this.filteredItems,
      event.previousIndex,
      event.currentIndex
    );

    // Mark the moved item for visual feedback
    const movedItem = this.filteredItems[event.currentIndex];
    this.movedItemId = movedItem.id || `index-${event.currentIndex}`;

    // Clear the visual marker after 3 seconds
    setTimeout(() => {
      this.movedItemId = null;
    }, 3000);
  }

  saveReorder() {
    // Turn off reorder mode
    this.isReordering = false;
    // Emit the new order to the parent so it can be persisted
    this.reorderSaved.emit(this.filteredItems);
  }

  cancelReorder() {
    // Revert to original array
    this.filteredItems = [...this.originalItems];
    this.isReordering = false;
  }
}
